/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';

import RichTextProductSpecs from './richtext';
import TableProductSpecs from './table';
import DefinitionsListSpecs from './definitions-list';

const components = {
    richtext: RichTextProductSpecs,
    table: TableProductSpecs,
    'definitions-list': DefinitionsListSpecs,
};

export default function ProductSpecs({ sections }) {
    return (
        <article className="product-specs">
            { looppa(sections)((section, i) => (
                <section className="product-specs--section" key={i}>
                    {components[section.type] ? React.createElement(components[section.type], {
                        ...section.data,
                        notes: section.notes,
                        title_key: section.title_key,
                    }) : null}
                </section>
            ))}
        </article>
    );
}

ProductSpecs.propTypes = {
    sections: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-specs/index.js